import { createContext, useContext, useState, useEffect } from 'react';
import { restoreSession, logout as authLogout, getProfile } from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Optimistically seed from localStorage so protected routes don't flash
  const [user, setUser]       = useState(getProfile);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    restoreSession()
      .then(profile => setUser(profile))
      .finally(() => setLoading(false));
  }, []);

  function setLoggedIn(profile) { setUser(profile); }

  async function logout() {
    await authLogout();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, setLoggedIn, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
